import React, { useState } from "react";
import {
  CardHeader,
  CardContent,
  Card,
  Icon,
  Loader,
  Dimmer,
  Accordion,
  Button
} from "semantic-ui-react";
import { size } from "lodash";
import { SessionItem } from "./SessionItem";
import "./Sidebar.scss";

export function Sidebar(props) {
  const {
    weeks,
    subject,
    grade,
    reload,
    onReload,
    activeSession,
    setActiveSessionShow,
    activeWeek,
    setActiveWeek,
    isMobile,
    isVisible,
    toggleSidebar
  } = props;

  // Función para manejar selección de sesión y cerrar sidebar en mobile
  const handleSessionSelect = (session) => {
    setActiveSessionShow(session);
    if (isMobile && isVisible) toggleSidebar();
  };

  /**
   * Generates panels for each week to be used in an Accordion component.
   *
   * This code snippet maps over an array of `weeks`, creating a panel object for each week
   * that can be used with a Semantic UI Accordion component. Each panel object contains a `key`
   * derived from the week's `_id` property, a `title` object, and a `content` object.
   *
   * The `title` object includes a div element that displays the week's index and title. This div
   * also has an `onClick` event handler that updates the `activeWeek` state to the current week's
   * index, highlighting the active week.
   *
   * The `content` object conditionally renders either a nested Accordion component containing
   * `SessionItem` components for each session in the week or a div element indicating that no
   * sessions are available for the week. Each `SessionItem` is passed the session data, the
   * `activeSession`, a reload function `onReload`, and a function `setActiveSessionShow` to
   * update the display state of the active session.
   *
   * This approach allows for a dynamic creation of an Accordion's panels based on the provided
   * weeks and their sessions, enabling an interactive and hierarchical display of weeks and
   * their respective sessions.
   */
  const weekPanels = weeks.map((week) => ({
    key: `week-${week.id}`,
    title: {
      onClick: () => setActiveWeek(week),
      active: activeWeek?.index === week.index,
      content: (
        <div
          className={`week-container ${
            activeWeek?.index === week.index ? "active" : ""
          }`}
          index={week.index}
        >
          {`S${week.index + 1}: ${week.title}`}
        </div>
      ),
    },
    content: {
      active: activeWeek?.index === week.index,
      content:
        week.sessions && week.sessions.length > 0 ? (
          <Accordion.Accordion
            panels={week.sessions.map((session) => ({
              key: session.id,
              content: (
                <SessionItem
                  key={session.id}
                  session={session}
                  activeSession={activeSession}
                  onReload={onReload}
                  setActiveSessionShow={() => handleSessionSelect(session)}
                />
              ),
            }))}
          />
        ) : (
          <div>No hay sesiones disponibles para esta unidad.</div>
        ),
    },
  }));

  return (
    <>
      <div
        className={`sidebar session-sidebar${
          isMobile && isVisible ? " active" : ""
        }`}
      >
        <Card fluid>
          <CardContent className="content-header">
            <CardHeader>
              {subject == null && grade == null ? (
                <Loader active inline="centered" size="small" />
              ) : (
                <div className="session-title">
                  <Icon className="session-icon" name="book" />
                  {subject?.name}

                  {isMobile && (
                  <Button
                    color="red"
                    icon="close"
                    className="close-sidebar"
                    floated="right"
                    onClick={toggleSidebar}
                    size="tiny"
                    compact
                  />
                  )}
                </div>
              )}
            </CardHeader>
          </CardContent>
          {size(weeks) === 0 && !reload ? (
            <h1>No existen unidades</h1>
          ) : size(weeks) === 0 || reload ? (
            <CardContent className="content-list">
              <Dimmer active inverted>
                <Loader content="Cargando sesiones" />
              </Dimmer>
            </CardContent>
          ) : (
            <Accordion
              className="content-list"
              fluid
              styled
              panels={weekPanels}
            />
          )}
        </Card>
      </div>
      {/* Overlay blur para mobile sidebar */}
      {isMobile && isVisible && <div className="sidebar__overlay" onClick={toggleSidebar} />}
    </>
  );
}
